import { ListItemText as MuiListItemText } from '@mui/material';
import { forwardRef } from 'react';

import type { ListItemTextProps } from '@mui/material';

export const LIST_ITEM_TEXT_TEST_ID = 'list-item-text';

export const ListItemText = forwardRef((props: ListItemTextProps, ref) => (
  <MuiListItemText data-testid={LIST_ITEM_TEXT_TEST_ID} {...props} ref={ref} />
));
